import { Box, Typography } from '@mui/material'
import logoDark from "../assets/images/signin/logoDark.png";

const UnderReview = (props: any) => {
  const { status } = props;
  return (
    <Box sx={{ p: '20px' }}>
      <img src={logoDark} alt="Logo_Dark" className={`loginLogo`} />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '80vh' }}>
        <h1 className='primary-color'>Your ID verification process is {status}.</h1>
        <Typography>We will inform via email once your verification is completed.</Typography>
      </Box>
    </Box>
  )
}

export default UnderReview